import React from 'react';

const IconPause = props => (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 14V35M29 14V35" stroke="#104228" strokeWidth="2" strokeLinejoin="bevel"/>
        <path d="M32 5.66417C29.5502 4.59379 26.8444 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 20.1316 42.9017 16.5197 41 13.4592" stroke="#104228" strokeWidth="2"/>
    </svg>    
);

export default IconPause;